<template>
  <div>
    <div class="breadcrumb">
      跑步按钮广告 >
      <span v-if="edit === false">新增</span>
      <span v-if="edit !== false && !isLook">编辑</span>
      <span v-if="edit !== false && isLook">查看</span>

      <span>
        <el-button class="right_f" type="primary" @click="cancel"
          >取消</el-button
        >
        <el-button class="right_f" type="primary" @click="save" v-if="!isLook"
          >保存</el-button
        >
      </span>
    </div>
    <el-form ref="form" :rules="rules" :model="form" label-width="170px">
      <el-form-item label="活动名称:" prop="name">
        <el-input
          type="text"
          placeholder="app不展示，仅提供后台标记管理"
          v-model="form.name"
          style="width: 400px"
          :maxlength="20"
          show-word-limit
          :disabled="isLook"
        ></el-input>
      </el-form-item>
      <el-form-item label="按钮图片:" prop="imgUrl">
        <!-- <el-upload
          :action="actionUrl"
          :with-credentials="true"
          accept="image/*"
          name="uploadFile"
          type="drag"
          :thumbnail-mode="true"
          :on-error="handleError"
          :on-success="chenggong"
          :disabled="disabled"
        >
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload> -->
        <el-upload
          :action="actionUrl"
          :with-credentials="true"
          accept="image/*"
          name="uploadFile"
          type="drag"
          class="upload-demo"
          :thumbnail-mode="true"
          :on-error="handleError"
          :show-file-list="false"
          :on-success="chenggong"
          :style="{ 'pointer-events': isLook ? 'none' : '' }"
        >
          <img
            style="width: 100%; height: 100%"
            v-if="form.imgUrl"
            :src="form.imgUrl"
            class="avatar"
          />
          <div v-else>
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="发布时间:">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          placeholder="选择发布日期时间"
          :disabled="isLook"
          :clearable="false"
        >
        </el-date-picker>
          
        <el-button @click="form.startTime=''" :disabled="isLook">清除时间</el-button>

        如不选，择默认直接发布
      </el-form-item>
      <el-form-item label="失效时间:">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          placeholder="选择失效日期时间"
          :disabled="isLook"
          :clearable="false"
        >
        </el-date-picker>
        <el-button @click="form.endTime=''"  :disabled="isLook">清除时间</el-button>

        如不选，择默认不会自动失效
      </el-form-item>
      <select-school
        :disabled="isLook"
        :schObj="form.schObj"
        @changeVal="getVal"
        :isRoot="isRoot"
      ></select-school>
    </el-form>
  </div>
</template>

<script>
import selectSchool from "../../common/selectSch.vue";
export default {
  components: { selectSchool },
  data() {
    let checkStringNull = (rule, value, callback) => {
      if (value && value.trim()) {
        return callback();
      } else {
        return callback(new Error("输入不能为空"));
      }
    };
    return {
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      isLook: false,
      edit: false,
      isRoot: false, //isRoot,true:筛选学校；false:筛选校区；
      form: {
        name: "",
        imgUrl: "",
        startTime: "",
        endTime: "",
        schObj: {
          applicableCampus: "1", //1是部分校区 0是全部
          shieldedSchools: [], //屏蔽的学校
          openedSchools: [], //应用的学校
        },
      },
      rules: {
        name: [
          {
            required: true,
            validator: checkStringNull,
            message: "活动名称不能为空",
          },
        ],
        imgUrl: [
          {
            required: true,
            validator: checkStringNull,
            message: "按钮图片不能为空",
          },
        ],
      },
    };
  },
  watch:{
    form:{
      handler(n){
        console.log('监听form',n)
      },
      immediate:true,
      deep:true
    }
  },
  mounted() {
    //console.log("详情id", this.$route.query.id, this.$route.query.type);
    this.isLook = this.$route.query.type == "look" ? true : false;
    if (this.$route.query.id) {
      this.edit = true;
      this.$http({
        method: "GET",
        url:
          this.$util.domain +
          "/adminapi/v1/operate/button/queryByButtonId?buttonId=" +
          this.$route.query.id,
      }).then((res) => {
        console.log("详情idForm", res);
        if (res.data.error == 10000) {
          let data = res.data.data;
          // this.form=res.data.data;
          //   this.form.schObj.applicableCampus=res.data.data.allUnidFlag.toString()
          this.form = {
            id: this.$route.query.id,
            name: data.name,
            imgUrl: data.imgUrl,
            startTime: data.startTime,
            endTime: data.endTime == null ? "" : data.endTime,
            buttonCampusList:
              data.allUnidFlag == 0 ? data.buttonCampusList : [],
            allUnidFlag: data.allUnidFlag,
            schObj: {
              shieldedSchools: [],
              openedSchools: [],
              applicableCampus: data.allUnidFlag ? data.allUnidFlag + "" : "0",
            },
          };
          let schArray = data.buttonCampusList.map((item) => {
            return { name: item.campusName, rootUnid: item.unid };
          });
          data.allUnidFlag == 0
            ? (this.form.schObj.shieldedSchools = schArray)
            : (this.form.schObj.openedSchools = schArray);
        }
      });
    }
  },
  methods: {
    //**保存**//
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.startTime && this.form.endTime) {
            if (new Date(this.form.startTime) > new Date(this.form.endTime)) {
              this.$util.errorMsg("失效时间必须大于发布时间");
              this.form.endTime = "";
              return;
            }
          }
          if (
            this.form.schObj.applicableCampus == "1" &&
            this.form.schObj.openedSchools.length == 0
          ) {
            this.$util.errorMsg("请添加应用学校");
            return;
          }
          /* handle选择校区 */
          let rootUnids = [],
            schObj = this.form.schObj;
          if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
            for (let i = 0; i < schObj.shieldedSchools.length; i++) {
              rootUnids.push({
                campusName: schObj.shieldedSchools[i].name,
                unid: schObj.shieldedSchools[i].rootUnid * 1,
              });
            }
          } else if (
            schObj.applicableCampus == 1 &&
            schObj.openedSchools.length
          ) {
            for (let i = 0; i < schObj.openedSchools.length; i++) {
              rootUnids.push({
                campusName: schObj.openedSchools[i].name,
                unid: schObj.openedSchools[i].rootUnid * 1,
              });
            }
          }
          if (this.form.startTime instanceof Date) {
            this.form.startTime = this.jsDateFormatter(this.form.startTime);
          }
          if (this.form.endTime instanceof Date) {
            this.form.endTime = this.jsDateFormatter(this.form.endTime);
          }
          /* handle选择校区end */
          this.form.buttonCampusList = rootUnids;
          this.form.allUnidFlag = schObj.applicableCampus * 1;
          delete this.form.schObj;
          console.log("form表单", this.form);
          // if (this.edit) {
          //   //编辑接口
          //   url = this.$util.domain + "/adminapi/v1/operate/button/addOrEdit";
          // }
          let url = this.$util.domain + "/adminapi/v1/operate/button/addOrEdit";
          this.$http({
            url,
            method: "POST",
            body: JSON.stringify(this.form),
          }).then((response) => {
            if (response.data.error === 10000) {
              this.$util.successMsg(response.data.message);
              this.$router.push("/yunying/advert/runBtn");
            } else {
              this.$util.errorMsg(response.data.message);
            }
          });
        }
      });
    },
    getVal(res) {
      this.form.schObj = res;
      console.log(this.form.schObj);
    },
    /* 上传图片成功 */
    chenggong(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        //setTimeout(() => {
        this.form.imgUrl = response.data;
        console.log(this.form.imgUrl);

        // }, 1000);
      }
    },
    /**上传文件失败钩子**/
    handleError(response) {
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }
      this.$util.errorMsg("上传失败");
    },
    //取消返回
    cancel() {
      history.go(-1);
    },
    jsDateFormatter(dateInput) {
      // dateInput 是一个 js 的 Date 对象
      var year = dateInput.getFullYear();
      var month = dateInput.getMonth() + 1;
      var theDate = dateInput.getDate();
      var hour = dateInput.getHours();
      var minute = dateInput.getMinutes();
      var second = dateInput.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (theDate < 10) {
        theDate = "0" + theDate;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }

      if (second < 10) {
        second = "0" + second;
      }
      return (
        year +
        "-" +
        month +
        "-" +
        theDate +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
  },
};
</script>

<style>
 .el-date-editor__trigger.el-icon{
   /*  width: 0 !important; */
    height: 0 !important;
  }
  .el-icon-time:before {
    content: "";
}
</style>




// WEBPACK FOOTER //
// addRunBtn.vue?62a3ae00